// extracted by mini-css-extract-plugin
export default {"SearchBox":"SearchBox_SearchBox__L8xsB"};